import { createHistory } from "@reach/router"
import { useEffect } from "react"
import { useFormState } from "react-final-form"

const history = createHistory(window)

const Form = ({ onSubmit, onPageLeave, children }) => {
  const { values: formValues } = useFormState()

  useEffect(() => {
    const beforeUnloadHandler = () => onPageLeave(formValues)

    const unlistenLocationChange = history.listen(beforeUnloadHandler)
    window.addEventListener("beforeunload", beforeUnloadHandler)

    return () => {
      unlistenLocationChange()
      window.removeEventListener("beforeunload", beforeUnloadHandler)
    }
  }, [formValues, onPageLeave])

  return (
    <form
      noValidate
      onSubmit={onSubmit}
      sx={{
        display: "grid",
        gap: 4,
        gridTemplateColumns: ["auto", "repeat(2, 1fr)"],
        "& > *": {
          gridColumn: [null, "span 2"],
        },
      }}
    >
      {children}
    </form>
  )
}

export default Form
